import { AbstractJsonApiService } from '@ipensii/shared/data-access-shared';
import { Observable } from 'rxjs';

export class UserAdminService extends AbstractJsonApiService<unknown> {
  constructor() {
    super('auth/users');
  }

  passwordRecoveryRequest({ mainCredential }: { mainCredential: string }): Observable<string> {
    return this.http.post(`${this.url}/password-recovery-request/${mainCredential}`, null, {
      responseType: 'text',
    });
  }

  recoverPassword({ newPassword }: { newPassword: string }): Observable<boolean> {
    return this.http.put<boolean>(`${this.url}/recover/password`, newPassword);
  }
}
